import { DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'
import { IAd } from '../../ad'
import { AdBiddingProvider, IAdBiddingAdapter, IAdBiddingProviderConfig, IAdServiceAdapter } from '../adapter'

interface IWindow {
    apstag: any
    googletag: any
    deployads: any
}

declare let window: IWindow

export const WithAmazonBidding = <T extends Mixin<IAdServiceAdapter>>(Base: T) =>
    class extends Base implements IAdBiddingAdapter {
        public sortableEnabled: boolean
        protected amazonEnabled = false
        private biddingJsSrc = '//c.amazon-adsystem.com/aax2/apstag.js'
        private defaultAdServer = 'googletag'
        private defaultTimeoutMs = '2e3'
        private oopSizes = [[1, 1]]
        private amazonInitd = false
        /**
         * Configures account, ad server and timeout.
         */
        public initializeBidding(
            confs: IAdBiddingProviderConfig[], adServer = this.defaultAdServer, timeout = this.defaultTimeoutMs) {

            // multiple bidding providers are supported, so fetch conf by name
            const conf = confs.find((_) => _.client === AdBiddingProvider.AMAZON)
            if (conf) {
                this.amazonEnabled = true

                // setup global object
                window.apstag = window.apstag || {
                    _Q: [],
                    fetchBids: (...a: any[]) => window.apstag._Q.push(['f', a]),
                    init: (...a: any[]) => window.apstag._Q.push(['i', a]),
                    setDisplayBids: (): void => undefined, // ?
                }

                // configure
                window.apstag.init({
                    adServer,
                    bidTimeout: timeout,
                    pubID: conf.account,
                })

                // load JS
                DOMUtils.loadScript(this.biddingJsSrc)
            }
        }

        /**
         * Fetches bids, sets targeting, displays ads.
         */
        public requestAds(specificAds?: IAd[]): void {
            if (!this.amazonEnabled) {
                super.requestAds(specificAds)
                return
            }

            const slots = (specificAds || this.ads).map((ad) => ({
                sizes: ad.isOutOfPage() ? this.oopSizes : ad.sizes,
                slotID: ad.id
            }))

            // bidding requires 'disable initial load' behaviour
            if (!this.amazonInitd) {
                this.amazonInitd = true

                if(this.sortableEnabled) {
                    window.googletag.cmd.push(() => {
                        window.deployads.push(() => {
                            window.deployads.gpt.pubadsDisableInitialLoad()
                        })
                    })
                } else {
                    window.googletag.cmd.push(() => window.googletag.pubads().disableInitialLoad())
                }

            }

            // no ads to bid on
            if (!slots.length) {
                return
            }

            // fetch bids
            window.apstag.fetchBids({ slots }, () =>
                window.googletag.cmd.push(() => {
                    // sets bid info via targeting
                    window.apstag.setDisplayBids()

                    // call super to request ads
                    super.requestAds(specificAds)
                }))
        }
    }
